/* eslint-disable no-console */
const ANALYTICS_METHODS = [
  'trackSubmit',
  'trackClick',
  'trackLink',
  'trackForm',
  'pageview',
  'identify',
  'reset',
  'group',
  'track',
  'ready',
  'alias',
  'debug',
  'page',
  'once',
  'off',
  'on',
];

export function loadAnalyticsJsFromWindow(window) {
  // Taken from segment.com and slightly modified (mostly ES5 -> ES6 tweaks)
  // https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/quickstart/
  return function loadAnalyticsJs(segmentWriteKey, segmentLoadOptions = {}) {
    // Create a queue, but don't obliterate an existing one!
    // eslint-disable-next-line no-param-reassign
    window.analytics = window.analytics || [];
    const { analytics } = window;

    // If the real analytics.js is already on the page return.
    if (analytics.initialize) return analytics;

    // If the snippet was invoked already show an error.
    if (analytics.invoked) {
      if (window.console && console.error) {
        console.error('Segment snippet included twice.');
      }
      return analytics;
    }

    // Invoked flag, to make sure the snippet
    // is never invoked twice.
    analytics.invoked = true;

    // A list of the methods in Analytics.js to stub.
    analytics.methods = ANALYTICS_METHODS;

    // Define a factory to create stubs. These are placeholders
    // for methods in Analytics.js so that you never have to wait
    // for it to load to actually record data. The `method` is
    // stored as the first argument, so we can replay the data.
    analytics.factory = (method) => (...args) => {
      window.analytics.push([method].concat(args));
      return analytics;
    };

    // For each of our methods, generate a queueing stub.
    // eslint-disable-next-line no-restricted-syntax
    for (const method of ANALYTICS_METHODS) {
      analytics[method] = analytics.factory(method);
    }

    // Define a method to load Analytics.js from our CDN,
    // and that will be sure to only ever load it once.
    analytics.load = (key, options) => {
      // Create an async script element based on your key.
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = `//cdn.segment.com/analytics.js/v1/${key}/analytics.min.js`;
      // when the script is fully loaded window.analytics.initialized will be
      // true

      // Insert our script next to the first script element.
      const first = document.getElementsByTagName('script')[0];
      first.parentNode.insertBefore(script, first);
      // eslint-disable-next-line no-underscore-dangle
      analytics._loadOptions = options;
    };

    // eslint-disable-next-line no-underscore-dangle
    analytics._writeKey = segmentWriteKey;

    // Add a version to keep track of what's in the wild.
    analytics.SNIPPET_VERSION = '4.13.2';

    // Load Analytics.js with your key, which will automatically
    // load the tools you've enabled for your account. Boosh!
    analytics.load(segmentWriteKey, segmentLoadOptions);

    return analytics;
  };
}
